import { useEffect } from 'react';
import { createBonkGatewayClient } from '../utils/backend/session';

const bonkSocket = createBonkGatewayClient(process.env.REACT_APP_BACKEND_URL!, process.env.REACT_APP_BACKEND_APIKEY!);

export const useBonkGateway = () => {
    useEffect(() => {
        bonkSocket.on('connect', () => console.debug('[BonkGateway] Connected', bonkSocket.id));
        bonkSocket.on('connect_error', () => console.debug('[BonkGateway] Connection error'));
        bonkSocket.on('disconnect', () => console.debug('[BonkGateway] Disconnected'));

        bonkSocket.connect();

        return () => {
            bonkSocket.off('connect');
            bonkSocket.off('connect_error');
            bonkSocket.off('disconnect');
            bonkSocket.disconnect();
        };
    }, []);

    return { bonkGatewayClient: bonkSocket };
};
